import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  gap: 16px;
`

export const List = styled.ol`
  margin-left: 16px;
  list-style: decimal;

  li + li {
    margin-top: 10px;
  }
`

export const ListItem = styled.div`
  display: grid;
  gap: 16px;
  justify-items: flex-start;
`

export const Bold = styled.span`
  font-weight: 600;
`

export const TagSelectContainer = styled.div`
  width: 100%;
`
